// extracted by mini-css-extract-plugin
export var measureBox = "_94-0";